module.exports = __webpack_public_path__ + "files/95c0a651e587c1afaef47fc529bfb8ab.svg";